import HeroContainer from "./hero-slider/";
import Listings from "./featured/listings";
import Press from "./press/press";
import React, { Component } from "react";
import Search from "../../containers/homepage/search-widget";
import Teaser from "./agent/teaser";
import Testimonials from "./testimonials/testimonials";
import Welcome from "./welcome/welcome";
import { getAgentIds, parsePage, updateOfficeSelect } from "../shared/util";
import request from "superagent";
import { USER_MANAGER } from "../../constants/constants";
import { postRequest } from "../../actions/api";
class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        activePage: parsePage(props),
        agentId: getAgentIds(props.entity),
        agentSelect: true,
        listingType: "sale",
        resultsPerPage: 15,
        sortField:
          props.entity.siteOptions.selectSoldsPage.sortField === "price"
            ? "soldPrice"
            : props.entity.siteOptions.selectSoldsPage.sortField,
      },
      resultSale: [],
      selectTitle: "Solds",
    };
  }
  componentDidMount() {
    this.setState(
      {
        // test below for manager
        filter: updateOfficeSelect(
          this.state.filter,
          this.props.entity.agentType,
          this.props.entity
        ),
      },
      () => {
        let filterCount = {
          agentId: getAgentIds(this.props.entity),
          agentSelect: true,
        };
        postRequest("/api/solds/counts", filterCount).then((response) => {
          if (
            response &&
            (response.salesCount > 0 || response.rentalsCount > 0)
          ) {
            let filterState = this.state.filter,
              titleSale = "Solds";
            if (response.salesCount > 2) {
              filterState.listingType = "sale";
              filterState.resultsPerPage = response.salesCount;
            } else {
              delete filterState.listingType;
              delete filterState.resultsPerPage;
            }
            if (response.salesCount == 0 && response.rentalsCount > 0) {
              titleSale = "Rental";
            }
            request
              .post("/api/solds")
              .set("Content-Type", "application/json")
              .send(filterState)
              .end((error, response) => {
                if (response && response.body) {
                  this.setState({
                    resultSale: response.body.results,
                    selectTitle: titleSale,
                  });
                } else {
                  console.error(error);
                }
              });
          } else {
          }
        });
      }
    );
  }
  render() {
    const siteOptions = this.props.entity.siteOptions || {};
    const {
      actions,
      entity,
      defaultOptions,
      featuredListings,
      heroListings,
      ourAdvantageSlides,
      press,
      testimonials
    } = this.props;

    return (
      <div className="homepage">
        <Search
          region={entity.region.urlPart}
          show={siteOptions.heroSliderOptions.showSearchBar}
        />
        <HeroContainer
          entity={entity}
          actions={actions}
          defaultOptions={defaultOptions}
          heroListings={heroListings}
        />
        <Welcome siteOptions={siteOptions} />
        <Teaser entity={entity} />
        <Press
          pressItems={press ? press.results : []}
          defaultOptions={defaultOptions}
        />
        <Listings listings={featuredListings} defaultOptions={defaultOptions} />
        {siteOptions.showSelectSoldsPage ? (
          <Listings
            name={
              entity.agentType === USER_MANAGER
                ? `Office Select ${this.state.selectTitle}`
                : `Select ${this.state.selectTitle}`
            }
            listings={this.state.resultSale}
            defaultOptions={defaultOptions}
          />
        ) : (
          ""
        )}

        <div style={{ height: "75px" }}></div>
        <Testimonials entity={entity} testimonialsTree={testimonials}/>
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/homepage/homepage.js